import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {findDOMNode} from 'react-dom';
import _ from 'lodash';

import * as Misc from '../../misc';
import * as PSActions from './../ProjectScope/ProjectScopeActions';
import * as Actions from './../../actions/index';
import A from './FeatureCreatorNewActions';
import template from '../../templates/FeatureCreator/FeatureCreatorCardNew.rt';
import {AccessRights} from '../../schemas/accessRightsModel';
import {getActiveFeatureImageStyleStateless} from '../../selectors/features';
import {showNewFeatureOverlay} from "./NewFeature/NewFeatureActions";
import {ToggleLinkPopup} from './ToggleLinkPopup';
import {UNIT_MEASUREMENTS} from "../../utilities";
import {setQuestionPopupState} from "../../actions/A_Popups";
import AllFeaturesActions from "./FeatureCreatorNewActions";
import {getCurrentFeatureToolSettings, getNewUnlinkedDataObject} from "../FeaturesSetup/featuresFunctions";

function mapStateToProps(state, props) {
  const {feature} = props;
  const AR = AccessRights.get(state);
  const canEdit = AR.isSiteAdmin(false) || AR.isFabMaster() || AR.isFabAdmin();
  const canDelete = AR.isSiteAdmin(true);
  const {auth, featuresCreatorNew} = state;
  const hasKitchenSub = auth.hasKitchenSub || AR.isSiteAdmin(false);
  const hasBathroomSub = auth.hasBathroomSub || AR.isSiteAdmin(false);
  const hasFireplaceSub = auth.hasFireplaceSub || AR.isSiteAdmin(false);
  const hasLaundryRoomSub = auth.hasLaundryRoomSub || AR.isSiteAdmin(false);

  var kvLayerState = feature.kvLayerState;
  var bvLayerState = feature.bvLayerState;

  if(!AR.isSiteAdmin(true)) {
    if(kvLayerState == "MORE")
      kvLayerState = "EXACT";
    if(bvLayerState == "MORE")
      bvLayerState = "EXACT";
  }

  return {
    ...feature,
    toolSettings: getCurrentFeatureToolSettings(feature),
    imageStyle: getActiveFeatureImageStyleStateless(props.groupName),
    AR,
    canEdit,
    canDelete,
    hasKitchen: hasKitchenSub,
    hasBathroom: hasBathroomSub,
    hasFireplace: hasFireplaceSub,
    hasLaundryRoom: hasLaundryRoomSub,
    kvLayerState,
    bvLayerState,
    style: {...props.style},
    updateItemCount: _.size(featuresCreatorNew.pendingFeatures),
    catId: state.routing.locationBeforeTransitions.query.catId,
    doNotShowLinkWarning: auth.doNotShowLinkWarning
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    showEditOverlay: (featureDefinitionId) => dispatch(showNewFeatureOverlay(true, ownProps.groupName, featureDefinitionId)),
    deleteFeature: (feature) => dispatch(PSActions.deleteFeature(feature)),
    updateFeatureData: ({id, propName, propValue, isFromEnabled}) =>
      dispatch(A.updateFeatureData({id, propName, propValue, isFromEnabled})),
    messageBoxShow: (title, message) => dispatch(Actions.messageBox_Show(true, 'system', title, message)),
    messageBoxOKCancelShow: (title, message, okCallback, cancelCallback) => dispatch(Actions.messageBoxComponent_Show(true, 'system', title, message, [
      {
        text: 'OK',
        onClick: () => {
          dispatch(Actions.messageBoxComponent_Show()); //reset to default props (not visible by default)
          okCallback();
        }
      },
      {
        text: 'Cancel',
        onClick: () => {
          dispatch(Actions.messageBoxComponent_Show()); //reset to default props (not visible by default)
          cancelCallback();
        }
      }
    ])),
    toggleWarningOff: (toggle) => toggle && dispatch(Actions.toggleWarningOff()),
    setQuestionPopupState: (questionPopupState) => dispatch(setQuestionPopupState(questionPopupState)),
    applyNewPropertyForAllFeatures: (propertyName, propertyValue) => {
      return dispatch(AllFeaturesActions.applyNewProperty(propertyName, propertyValue))
    }
  };
}

class FeatureCreatorCardNew extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showingVisibility: false,
      uofMOpened: false
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleUofMWrapperBlur);
  }

  updateUnlinkedData(propName, propValue) {
    let unlinkedData = {...this.props.unlinkedData};
    switch(propName) {
      case "hasQt":
        unlinkedData.hideFromKVQT = !propValue;
        break;
      case "hasKv":
        unlinkedData.hideFromKV = !propValue;
        break;
      case "hasBv":
        unlinkedData.hideFromBV = !propValue;
        break;
      case "hasBvQt":
        unlinkedData.hideFromBVQT = !propValue;
        break;
      case "name":
        unlinkedData.displayName = propValue;
        break;
      default:
        unlinkedData[propName] = propValue; // toolSettings, cost, price
        break;
    }
    this.updateData('unlinkedData', unlinkedData);
    this.updateData('unlinkedDataJson', JSON.stringify({[this.props.catId]: unlinkedData}));
  }

  /**
   *
   * @param propName {string}
   * @param propValue
   */
  updateData = (propName, propValue) => {
    if(this.props.unlinkedData) {
      switch(propName) {
        case "toolSettings":
        case "price":
        case "cost":
        case "name":
          this.updateUnlinkedData(propName, propValue);
          return;
      }
    }

    this.props.updateFeatureData({
      id: this.props.featureDefinitionId,
      propName,
      propValue,
      isFromEnabled: !!this.props.isFromEnabled
    });
  }

  onChangePrice = (event, property = "cost") => {
    const
      value          = event.target.value,
      rgx            = /^[0-9]*\.?[0-9]*$/;
    if (!value.match(rgx) || value.toString().length > 10) {
      return false;
    }
    this.updateData(property, value); // edit as string
  }

  onBlurPrice = (event, property = "cost") => {
    let value = event.target.value;
    this.finishPriceEditing(value, property);
  };

  finishPriceEditing = (value, property) => {
    let stringValue = value.toString();
    if (stringValue.includes('.')) {
      if (stringValue.indexOf('.') === 0) {
        stringValue = "0"+stringValue;   // dot on the beginning
      }
      if (stringValue.indexOf(".") === (stringValue.length - 1)) {
        stringValue = stringValue.substring(0, stringValue.length - 1); // dot on the end
      }
      stringValue = (+stringValue).toFixed(2);
    }
    this.updateData(property, +stringValue || 0); // set as number
  };

  onChangeUnit = (unit) => {
    this.props.setQuestionPopupState({
      showPopup: true,
      questionMessage: "Do you want to apply this unit measurement on all features?",
      yesClick: () => {
        this.props.applyNewPropertyForAllFeatures('uofM', unit);
      },
      noClick: () => {
        this.updateData('uofM', unit);
      }
    })
  };

  handleUofMButtonClick = () => {
    this.setState({
      uofMOpened: !this.state.uofMOpened
    }, () => {
      setTimeout(() => {
        if (this.state.uofMOpened) {
          document.addEventListener('click', this.handleUofMWrapperBlur);
        } else {
          document.removeEventListener('click', this.handleUofMWrapperBlur);
        }
      }, 0)
    })
  };

  handleUofMWrapperBlur = (e) => {
    // if (!e.target.closest('.lightbox-drop-down-lir')) {
    //   this.handleUofMButtonClick();
    // }
    this.handleUofMButtonClick();
  };

  toggleVisibility = (val, tool) => {
    let toolSettings = this.props.toolSettings;
    let bFound = false;

    for(var idx in toolSettings) {
      if(toolSettings[idx].tool == tool) {
        toolSettings[idx][val] = !toolSettings[idx][val]
        bFound = true;
      }
    }
    if (!bFound) {
      toolSettings.push({
        tool,
        [val]: true,
        fabricatorFeatureId: this.props.fabricatorFeatureId
      });
    }

    this.updateData('toolSettings', toolSettings);
    if (!this.props.unlinkedData) {
      this.updateData('toolSettings_save', JSON.stringify(toolSettings));
      const enabled = toolSettings.some(field => field.enableVisualizer || field.enableQuotingTool);
      this.updateData('enabled', enabled);
    }
  };

  toggleLock = () => {
    this.updateData('unlocked', !this.props.unlocked);
  }

  checkVisibility = (val, tool) => {
    var toolSetting = _.first(this.props.toolSettings.filter(_ => _.tool == tool));
    if(toolSetting != null)
      return toolSetting[val];
  }

  handleVisibilityClick = (e, val, tool) => {
    Misc.ignoreDefault(e);
    if (this.props.canEdit) {
      this.toggleVisibility(val, tool);
    }
  }

  handlePopupOnBlur = () => {
    this.setState({showingVisibility: false});
  }

  handleDelete = (feature) => {
    if (this.props.canDelete) {
      this.props.deleteFeature(feature);
    }
  }

  onChangeDisplayName = (name) => {
    if (name.length) {
      this.updateData('name', name);
    }
  }

  showEditOverlay = () => {
    if(this.props.updateItemCount > 0) {
      var title = 'Pending Changes';
      var message = 'Unable to edit a feature when there are pending changes. Please "Save" or "Cancel" pending changes and try again.';
      this.props.messageBoxShow(title, message);
    } else {
      this.props.showEditOverlay(this.props.featureDefinitionId);
    }
  }

  toggleWarning = (checked) => {
    this.setState({toggleWarningOff: checked});
  }

  toggleLink = () => {
    const {price, cost, toolSettings, catId} = this.props;
    const newData = getNewUnlinkedDataObject({price, cost, toolSettings}, catId);
    if(!this.props.doNotShowLinkWarning) {
      let message = (<ToggleLinkPopup hasUnlinkedData={!!this.props.unlinkedData} onChecked={this.toggleWarning} />);
      if(this.props.unlinkedData) {
        this.props.messageBoxOKCancelShow('Reconnect Item', message, () => {
          this.props.toggleWarningOff(this.state.toggleWarningOff);
          this.updateData('unlinkedData', null);
          this.updateData('unlinkedDataJson', JSON.stringify({[this.props.catId]: null}));
        }, () => false);
      } else {
        this.props.messageBoxOKCancelShow('Separate Item', message, () => {
          this.props.toggleWarningOff(this.state.toggleWarningOff);
          this.updateData('unlinkedData', newData);
          this.updateData('unlinkedDataJson', JSON.stringify({[this.props.catId]: newData}));
        }, () => false);
      }
    } else {
      if(this.props.unlinkedData) {
        this.updateData('unlinkedData', null);
        this.updateData('unlinkedDataJson', JSON.stringify({[this.props.catId]: null}));
      }
      else {
        this.updateData('unlinkedData', newData);
        this.updateData('unlinkedDataJson', JSON.stringify({[this.props.catId]: newData}));
      }
    }
  }


  render = template
}

FeatureCreatorCardNew.propTypes = {
  feature: PropTypes.object.isRequired,
  updateFeatureData: PropTypes.func.isRequired,
  isFromEnabled: PropTypes.bool.isRequired
};

const FeatureCreatorCard = connect(mapStateToProps, mapDispatchToProps)(FeatureCreatorCardNew);

export {FeatureCreatorCard};
